import { snakeCase } from 'lodash';

export const getActionType = (actionName, moduleName = 'GUARDIAN_CLAIM') =>
  `${moduleName}/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});
